// Кука-флаг «в приложении есть сессия» — для лендинга backdoor.tech.
//
// Токены живут в localStorage app.backdoor.tech и соседнему хосту недоступны,
// поэтому лендинг не может сам понять, показывать «Log in / Sign up» или
// «Dashboard». Единственный общий канал — кука на родительском домене
// `.backdoor.tech` (тот же приём, что и bd-consent, см. consent/storage.ts).
//
// Значение — просто "1": никаких токенов и PII, только факт. Срок — 30 дней,
// продлевается при каждом логине/обновлении токена и снимается в clearAuth.
// Если refresh-токен умер раньше, чем кука, лендинг покажет «Dashboard», а
// приложение на входе само отправит на логин — деградация мягкая.
//
// КОНТРАКТ с backdoor-tech-app/lib/session.ts: имя куки и домен менять синхронно.

export const SESSION_COOKIE_KEY = "bd-session";

const MAX_AGE = 60 * 60 * 24 * 30; // 30 дней

function hasDom(): boolean {
  return typeof document !== "undefined" && typeof window !== "undefined";
}

function cookieAttrs(maxAge: number): string {
  const h = window.location.hostname;
  const domain =
    h === "backdoor.tech" || h.endsWith(".backdoor.tech") ? "; domain=.backdoor.tech" : "";
  const secure = window.location.protocol === "https:" ? "; secure" : "";
  return `${domain}; path=/; max-age=${maxAge}; samesite=lax${secure}`;
}

export function markSessionActive(): void {
  if (!hasDom()) return;
  document.cookie = `${SESSION_COOKIE_KEY}=1${cookieAttrs(MAX_AGE)}`;
}

export function clearSessionFlag(): void {
  if (!hasDom()) return;
  document.cookie = `${SESSION_COOKIE_KEY}=${cookieAttrs(0)}`;
}
